var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('iframe',{staticStyle:{"width":"100%","height":"1024px"},attrs:{"src":_vm.src,"frameborder":"0","scrolling":"no"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }